import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { WHATSAPP_URL } from '../utils/constants';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Áreas de Práctica',
    href: '#areas'
  }, {
    name: 'Equipo',
    href: '#equipo'
  }, {
    name: 'Experiencia',
    href: '#experiencia'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-grayMid py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-130">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-131">
        {/* Logo */}
        <a href="#inicio" className="flex items-center gap-3 group" data-id="element-132">
          <div className="relative w-8 h-8 flex items-center justify-center border border-grayDarkest" data-id="element-133">
            <div className="w-4 h-4 bg-grayDarkest" data-id="element-134"></div>
          </div>
          <div className="flex flex-col" data-id="element-135">
            <span className="font-montserrat font-bold text-xl tracking-widest text-grayDarkest leading-none" data-id="element-136">
              VELASCO
            </span>
            <span className="font-montserrat text-[10px] tracking-[0.3em] text-grayMedium mt-1" data-id="element-137">
              & ASOCIADOS
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-138">
          <ul className="flex items-center gap-6" data-id="element-139">
            {navLinks.map(link => <li key={link.name} data-id="element-140">
                <a href={link.href} className="text-sm text-grayDarkest hover:text-grayMedium transition-colors font-medium tracking-wide" data-id="element-141">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="bg-grayDarkest text-white px-6 py-2.5 font-montserrat font-semibold text-sm uppercase tracking-wider hover:bg-grayMedium transition-colors duration-300" data-id="element-142">
            Agendar Consulta
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-grayDarkest p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-143">
          {mobileMenuOpen ? <X size={24} data-id="element-144" /> : <Menu size={24} data-id="element-145" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-grayMid p-6 flex flex-col gap-4 shadow-lg" data-id="element-146">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg text-grayDarkest hover:text-grayMedium transition-colors font-medium" data-id="element-147">
              {link.name}
            </a>)}
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="bg-grayDarkest text-white px-6 py-3 font-montserrat font-semibold text-center uppercase tracking-wider mt-4" data-id="element-148">
            Agendar Consulta
          </a>
        </div>}
    </nav>;
}